export const OPEN_BUY_POINT = 'OPEN_BUY_POINT'
export const CLOSE_BUY_POINT = 'CLOSE_BUY_POINT'
